import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import saveAnswerFile from "./saveAnswerFile";
import uri from "../../../constants/uri";
import { answerTypeMap } from "../../../constants/answerType";

const createAnswer = async (answer, QuestionId, order, type) => {
	const {
		data: { id: answerId },
	} = await client.post(
		`${uri}/item`,
		{
			QuestionId,
			TypeId: answerTypeMap[type],
			OrderNum: order,
			Name: answer.text || "",
		},
		{
			headers: authHeader(),
		}
	);
	if (answer.files && answer.files.length > 0) {
		await Promise.all(
			answer.files.map((file) => {
				saveAnswerFile(file, answerId);
			})
		);
	}
};

export default createAnswer;
